<script setup lang="ts">
/**
 * 底部购物车栏。
 *
 * 合计是「过渡显示」——真钱以服务端试算为准，这一点在确认页会体现出来。
 * 这里用 shared 的整数分函数算，绝不出现浮点误差（0.29 × 3 必须等于 87 分）。
 */
import { computed } from 'vue';
import { formatYuan } from '@jinhua/shared';
import { kiosk } from '../stores/kiosk';

const emit = defineEmits<{ (e: 'checkout'): void; (e: 'clear'): void; (e: 'open'): void }>();

const count = computed(() => kiosk.cartCount.value);
const subtotalText = computed(() => formatYuan(kiosk.cartSubtotalCents.value));
</script>

<template>
  <div class="cartbar panel">
    <button class="cartbar__left" :disabled="count === 0" @click="emit('open')">
      <span class="cartbar__icon">🛒</span>
      <span v-if="count > 0" class="cartbar__count">{{ count }}</span>
      <span class="cartbar__amount amount">¥{{ subtotalText }}</span>
    </button>

    <button v-if="count > 0" class="btn btn--ghost cartbar__clear" @click="emit('clear')">清空</button>

    <button class="btn btn--primary cartbar__go" :disabled="count === 0" @click="emit('checkout')">
      去结算
    </button>
  </div>
</template>

<style scoped>
.cartbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin: 0 0 14px;
  flex: 0 0 auto;
}

.cartbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: var(--touch);
  padding: 0 16px;
  border-radius: 14px;
  background: var(--panel-2);
}

.cartbar__icon {
  font-size: 28px;
}

.cartbar__count {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--brand);
  color: #fff;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cartbar__amount {
  font-size: 30px;
  color: #ffd08a;
}

.cartbar__clear {
  margin-left: auto;
}

.cartbar__go {
  min-width: 190px;
  font-size: 26px;
}

@media (max-width: 860px) {
  .cartbar {
    padding: 8px 10px;
    gap: 8px;
    margin-bottom: 10px;
  }

  .cartbar__left {
    min-height: 56px;
    padding: 0 10px;
    gap: 8px;
  }

  .cartbar__icon {
    font-size: 22px;
  }

  .cartbar__count {
    min-width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .cartbar__amount {
    font-size: 22px;
  }

  /* 手机上「清空」太容易误触，而且一按就把整车清了。
     购物车明细里每一行都有「删除」，够用了。 */
  .cartbar__clear {
    display: none;
  }

  .cartbar__go {
    min-width: 0;
    font-size: 18px;
    padding: 0 22px;
  }
}

</style>
